module.exports = __webpack_public_path__ + "static/img/Front Eureka_4.ee4f4f30.png";